import React from 'react';
import './PetAnimations.css';

export default function PocketPhoenixSvg({ size = 120, color, className = '' }) {
  const bodyColor = color || '#F26A1F';
  const flameYellow = '#FFD24A';
  const flameRed = '#D32B1F';
  const beak = '#FFB23E';

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      fill="none"
      className={`pet-svg pet-idle ${className}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Outer flame halo */}
      <circle cx="60" cy="60" r="42" fill={flameYellow} opacity="0.1" />
      {/* Left flame wing */}
      <path d="M34 60C18 56 8 44 14 30C20 36 26 42 30 50C28 38 30 28 38 22C40 32 40 44 38 56Z" fill={flameRed} />
      <path d="M34 60C22 58 14 50 18 38C24 42 30 50 32 56C30 46 32 36 38 30C40 38 40 50 38 58Z" fill={bodyColor} />
      <path d="M36 58C28 56 22 50 24 42C30 44 34 50 36 54Z" fill={flameYellow} />
      {/* Right flame wing */}
      <path d="M86 60C102 56 112 44 106 30C100 36 94 42 90 50C92 38 90 28 82 22C80 32 80 44 82 56Z" fill={flameRed} />
      <path d="M86 60C98 58 106 50 102 38C96 42 90 50 88 56C90 46 88 36 82 30C80 38 80 50 82 58Z" fill={bodyColor} />
      <path d="M84 58C92 56 98 50 96 42C90 44 86 50 84 54Z" fill={flameYellow} />
      {/* Body */}
      <ellipse cx="60" cy="64" rx="16" ry="20" fill={bodyColor} />
      {/* Belly */}
      <ellipse cx="60" cy="68" rx="10" ry="14" fill={flameYellow} opacity="0.9" />
      {/* Tail feathers (flame plumes) */}
      <path d="M50 84C46 96 50 100 56 94C58 100 62 100 64 94C70 100 74 96 70 84Z" fill={flameRed} />
      <path d="M54 88C52 96 56 98 60 92C64 98 68 96 66 88Z" fill={bodyColor} />
      {/* Head */}
      <circle cx="60" cy="44" r="14" fill={bodyColor} />
      {/* Crest plumes */}
      <path d="M52 32L48 18L56 28Z" fill={flameRed} />
      <path d="M60 30L60 16L64 28Z" fill={flameYellow} />
      <path d="M68 32L72 18L64 28Z" fill={flameRed} />
      {/* Eyes */}
      <circle cx="55" cy="44" r="2.5" fill="white" />
      <circle cx="65" cy="44" r="2.5" fill="white" />
      <circle cx="55" cy="44" r="1.4" fill="#2C2419" />
      <circle cx="65" cy="44" r="1.4" fill="#2C2419" />
      {/* Beak */}
      <path d="M58 50L60 56L62 50Z" fill={beak} />
      {/* Little feet */}
      <path d="M56 84L54 90M58 84L58 90" stroke={beak} strokeWidth="1.5" strokeLinecap="round" />
      <path d="M64 84L66 90M62 84L62 90" stroke={beak} strokeWidth="1.5" strokeLinecap="round" />
      {/* Embers */}
      <circle cx="22" cy="80" r="1.5" fill={flameYellow} opacity="0.7" />
      <circle cx="98" cy="80" r="1.5" fill={flameYellow} opacity="0.7" />
      <circle cx="30" cy="92" r="1" fill={flameRed} opacity="0.6" />
      <circle cx="90" cy="92" r="1" fill={flameRed} opacity="0.6" />
    </svg>
  );
}
